module.exports = __webpack_public_path__ + "static/media/schoolpic01@2x.422cb2ce.png";